import type { Theme } from '@mui/material';

const backgroundColorMap = (theme: Theme) => ({
  secondary: theme.colors.secondary[50],
  neutral: theme.colors.neutral[50],
});

const highlightedBackgroundColorMap = (theme: Theme) => ({
  secondary: theme.colors.white,
  neutral: theme.colors.neutral[400],
});

const colorMap = (theme: Theme) => ({
  secondary: theme.colors.secondary[800],
  neutral: theme.colors.neutral[800],
});

export const styles = {
  languageSelector: (color: 'secondary' | 'neutral') => (theme: Theme) => ({
    textTransform: 'uppercase',
    bgcolor: backgroundColorMap(theme)[color],
    svg: { fill: colorMap(theme)[color] },
    minWidth: '4.5rem',

    fieldset: {
      border: 'none',
    },

    '.MuiSelect-select': {
      color: colorMap(theme)[color],
      bgcolor: backgroundColorMap(theme)[color],
      boxShadow: `initial`,
      fontWeight: 500,
      pt: 1,
      pb: 1,
      pl: 2,
      pr: 4,
    },
  }),

  menuItem: (color: 'secondary' | 'neutral') => (theme: Theme) => ({
    textTransform: 'uppercase',
    '&.Mui-selected': {
      backgroundColor: 'inherit !important',
      '> *': {
        color: theme.colors.neutral[800],
      },
    },

    '&:before': {
      content: '" "',
      height: '100%',
      position: 'absolute',
      left: 0,
      right: 0,
      ml: 0.5,
      mr: 0.5,
      borderRadius: '4px',
      backgroundColor: highlightedBackgroundColorMap(theme)[color],
      visibility: 'hidden',
    },

    '&:hover': {
      backgroundColor: 'inherit',

      '&:before': {
        visibility: 'visible',
      },
    },
  }),

  menuItemLabel: (theme: Theme) => ({
    lineHeight: 'inherit',
    display: 'block',
    fontWeight: theme.typography.fontWeightSemiBold,
    zIndex: 1,
  }),

  menuProps: (color: 'secondary' | 'neutral') => (theme: Theme) => ({
    bgcolor: backgroundColorMap(theme)[color],
    color: colorMap(theme)[color],
    mt: '3px',
    boxShadow: '0 0.25rem 1.4375rem 0 #00000014',
  }),
};
